	module.exports = (fox) => {
		'use strict';
	
		require('../templates/expremium.a.tpl')(fox);
		require('../css/_gui-elem.css');
	
		fox.registerWidget('ExpremiumUser_Popup', {
			configure: function () {
				this.registerOptions('', {
					dialog: {
						title: 'Attention!',
						width: '340px',
						'!dialogClass': 'dlg-amc dark-overlay mc-site-common-popup gdpr-popup'
					},
					widgets: {
						content: {
							template: 'ex_premium_user',
						}
					},
					handleDom: {
						close: {
							targetWidget: '#content',
							target: '.close',
							callback: 'hide'
						}
					},
				});
	
				this.callParent('configure', arguments);
			},

			running() {
				const w = this.rwom1('#content');
				const exCookie = fox.cookie.get('exPrem') || false;
				const exPremium = fox.utils.localStorage('getItem', 'exPremiumUser') || false;
				var name = window.location.hostname;
				w.setTemplateOptions('siteName', name);
				w.render()
				if(exPremium && !exCookie){
					setTimeout(() => {
						//this.showPopup();
						fox.cookie.set('exPrem', 'on');
						fox.utils.localStorage('setItem', 'exPremiumUser', 0);
					}, 3000); 
				}
			},
			showPopup() {
				this.show();
			},
			hidePopup() {
				this.hide();
			},
		}, 'Popup_Common');
	}



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/expremiumuser/widget/expremiumUserPopup.es.js